import { Component, OnInit } from '@angular/core';
import { JackpotHrService } from '../jackpot-hr.service';
import { JackpotWheelComponent } from '../jackpot-wheel/jackpot-wheel.component';
import { JackpotStatsComponent } from '../jackpot-stats/jackpot-stats.component';
import { JackpotSkinsRowComponent } from '../jackpot-skins-row/jackpot-skins-row.component';
import { JackpotInfoBarComponent } from '../jackpot-info-bar/jackpot-info-bar.component';
import { JackpotBetsComponent } from '../jackpot-bets/jackpot-bets.component';

@Component({
  selector: 'app-jackpot-highroller',
  templateUrl: './jackpot-highroller.component.html',
  styleUrls: ['./jackpot-highroller.component.scss'],
  standalone: true,
  imports: [
    JackpotWheelComponent,
    JackpotStatsComponent,
    JackpotSkinsRowComponent,
    JackpotInfoBarComponent,
    JackpotBetsComponent,
  ],
})
export class JackpotHighrollerComponent implements OnInit {
  constructor(public jackpot: JackpotHrService) {}

  ngOnInit(): void {
    this.jackpot.switchPot();
  }
}
